import classNames from 'classnames';
import React, { ReactElement } from 'react';
import { Icon } from '../../../Icon';
import styles from './index.module.css';

export interface NestedLinksButtonProps {
  handleOnClick: VoidFunction;
  label: string;
  isActive: boolean;
}

export function NestedLinksButton({
  handleOnClick,
  label,
  isActive,
}: NestedLinksButtonProps): ReactElement {
  return (
    <button
      className={classNames(styles.root, styles.chevron, {
        [styles['active']]: isActive,
      })}
      onClick={handleOnClick}
    >
      <span className={styles.label}>{label}</span>
      <Icon
        className={styles.icon}
        name={isActive ? 'chevron-up' : 'chevron-down'}
      />
    </button>
  );
}
